import React from 'react';
import ProductImages from './ProductImages';
import ProductInfo from './ProductInfo';
import './styles/TopSection.css';
import './styles/TopSection.mobile.css';

interface ProductVariant {
  id: string;
  size: string;
  price: number;
  pricePerMeter: number;
  rollLength: number;
  variantImage?: string;
  variantImages?: string[];
}

interface ImageZoomProps {
  mainImage: string;
  thumbnailImages: string[];
  productName: string;
  productId: string;
  title: string;
  basePrice: number;
  pricePerMeter: number;
  variants: ProductVariant[];
  hierarchicalVariants?: any[];
  variantHierarchy?: string[];
  mainProductImage: string;
  compareAtPrice?: number;
  quantity?: number;
  onAddToCart: (variantId: string, quantity: number) => void;
  onBuyNow: (variantId: string, quantity: number) => void;
  onVariantChange?: (variant: any) => void;
}

interface ZoomState {
  active: boolean;
  xPercent: number;
  yPercent: number;
  imageSrc: string;
}

const ImageZoom: React.FC<ImageZoomProps> = (props) => {
  const {
    mainImage,
    thumbnailImages,
    productName,
    productId,
    title,
    basePrice,
    pricePerMeter,
    variants,
    hierarchicalVariants,
    variantHierarchy,
    mainProductImage,
    compareAtPrice,
    quantity,
    onAddToCart,
    onBuyNow,
    onVariantChange
  } = props;

  const [zoomState, setZoomState] = React.useState<ZoomState>({
    active: false,
    xPercent: 50,
    yPercent: 50,
    imageSrc: mainImage
  });

  const [isDesktop, setIsDesktop] = React.useState(false);

  React.useEffect(() => {
    const handleResize = () => {
      if (typeof window !== 'undefined') {
        setIsDesktop(window.innerWidth >= 1024);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  React.useEffect(() => {
    setZoomState((prev) => ({
      ...prev,
      imageSrc: mainImage
    }));
  }, [mainImage]);

  const handleZoomChange = (data: { xPercent: number; yPercent: number; imageSrc: string }) => {
    if (!isDesktop) return;
    setZoomState({
      active: true,
      xPercent: data.xPercent,
      yPercent: data.yPercent,
      imageSrc: data.imageSrc
    });
  };

  const handleZoomEnd = () => {
    setZoomState((prev) => ({
      ...prev,
      active: false
    }));
  };

  return (
    <div className="top-section">
      <div className="top-section-container">
        <div className="images-section">
          <ProductImages
            mainImage={mainImage}
            thumbnailImages={thumbnailImages}
            productName={productName}
            onZoomChange={handleZoomChange}
            onZoomEnd={handleZoomEnd}
            isDesktop={isDesktop}
          />
        </div>

        <div className="info-section">
          <ProductInfo
            productId={productId}
            title={title}
            basePrice={basePrice}
            pricePerMeter={pricePerMeter}
            variants={variants}
            hierarchicalVariants={hierarchicalVariants}
            variantHierarchy={variantHierarchy}
            mainProductImage={mainProductImage}
            compareAtPrice={compareAtPrice}
            quantity={quantity}
            onAddToCart={onAddToCart}
            onBuyNow={onBuyNow}
            onVariantChange={onVariantChange}
            zoomImage={zoomState.imageSrc}
            zoomX={zoomState.xPercent}
            zoomY={zoomState.yPercent}
            isZoomActive={zoomState.active && isDesktop}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageZoom;

